import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bec19a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-zone" }
const _hoisted_2 = { class: "system-title" }
const _hoisted_3 = {
  key: 0,
  class: "cloud-information"
}
const _hoisted_4 = {
  key: 0,
  class: "sign dropdown"
}
const _hoisted_5 = {
  class: "btn dropdown-toggle btn-account",
  type: "button",
  id: "userNameDropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "user-name-zone" }
const _hoisted_7 = { class: "user-id" }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  class: "dropdown-menu",
  "aria-labelledby": "userNameDropdown"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "view-list" }
const _hoisted_13 = { class: "view-master" }

import { Authorize } from "@/components/api-authorization/AuthorizeService";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { setting } from "@/components/api-authorization/SettingService";
import { RootLoading } from "@/components/Loading";
import Loading from "@/components/Loading.vue";
import Diagnotics from "./components/diagnotics/Diagnotics.vue";
import { useI18n } from "vue-i18n";
import { setTitle } from "@/components/title";
import { isAxiosError } from "./plugins/Error";
import { alert } from "./components/diagnotics";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const isAuthenticated = Authorize.isAuthenticated;

const isLoading = RootLoading.isLoading;
/**
 * ユーザ
 */
const user = computed(() => {
  const _isAuthenticated = isAuthenticated.value;
  const user = Authorize.user.value;
  if (_isAuthenticated) {
    return user;
  }
  return null;
});
/**
 * ログインページである
 */
const isLoginPage = computed(() => {
  const route = router.currentRoute.value;
  const auth = isAuthenticated.value;
  return route.name == "Login" || !auth;
});
const isCloudMode = ref(false);
/**
 * ログインページ / クラウドモード / オンプレモード の切替を行う
 */
const changeMode = async () => {
  try {
    await setting.promise;
  } catch (e) {
    console.error(e);
    if (!isAxiosError(e)) throw e;
    await alert(t("ERROR.SYSTEM"));
  }
  // html要素への is-colud / on-premise クラスの適用
  const html = document.documentElement;
  const loginPage = isLoginPage.value;
  const isCloud = "is-cloud";
  const onPremise = "on-premise";
  const useCloud = "use-cloud";
  isCloudMode.value = setting.setting.isCloud;
  const isUseCloudPage =
    setting.setting.enableCloudUpload || setting.setting.isCloud;
  console.debug("watch isLoginPage", {
    loginPage,
    isCloudMode: isCloudMode.value,
  });
  if (loginPage) {
    html.classList.remove(isCloud);
    html.classList.remove(onPremise);
  } else if (isCloudMode.value) {
    html.classList.add(isCloud);
    html.classList.remove(onPremise);
  } else {
    html.classList.remove(isCloud);
    html.classList.add(onPremise);
  }
  if (isUseCloudPage) {
    html.classList.add(useCloud);
  } else {
    html.classList.remove(useCloud);
  }
};
changeMode();
/**
 * ログインページから切り替える度に
 * ページルートに is-cloud / on-premise クラスの付与・削除を試みる
 */
watch(isLoginPage, changeMode);
/**
 * ログアウトを行う
 */
async function onLogout() {
  await Authorize.logout();
  router.push({ name: "Login" });
}
{
  let mounted = false;
  function _setTitle() {
    if (!mounted) return;
    const title = setTitle.current.value;
    const areaName = t("APP.AREA_NAME");
    const systemName = t("APP.SYSTEM_NAME");
    document.title =
      title === undefined
        ? `${areaName} ${systemName}`
        : `${title} - ${areaName} ${systemName}`;
  }
  watch(setTitle.current, _setTitle);
  onMounted(() => {
    mounted = true;
    _setTitle();
  });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'is-login': !_unref(isLoginPage),
      'no-login': _unref(isLoginPage),
      'is-loading': _unref(isLoading),
    })
  }, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)("APP.AREA_NAME")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("APP.SYSTEM_NAME")), 1)
        ]),
        (!_unref(isLoginPage) && isCloudMode.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("APP.CLOUDINFORMATION")), 1))
          : _createCommentVNode("", true)
      ]),
      (!_unref(isLoginPage) && _unref(isAuthenticated))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_unref(t)("APP.USER_ID")), 1),
                  _createElementVNode("span", {
                    title: _unref(user)?.user?.staffId
                  }, _toDisplayString(_unref(user)?.user?.staffId), 9, _hoisted_8)
                ]),
                _createElementVNode("span", {
                  class: "user-name",
                  title: _unref(user)?.user?.staffName
                }, _toDisplayString(_unref(user)?.user?.staffName), 9, _hoisted_9)
              ])
            ]),
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "dropdown-item",
                  onClick: onLogout
                }, _toDisplayString(_unref(t)("APP.LOGOUT")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("article", null, [
      _createVNode(_component_router_view)
    ]),
    (_unref(isAuthenticated))
      ? (_openBlock(), _createElementBlock("nav", _hoisted_11, [
          _createElementVNode("ul", _hoisted_12, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/reports",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("REPORTS.TITLE")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/projects",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("PROJECTS.TITLE")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/templates",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("TEMPLATES.TITLE")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/users",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("USERS.TITLE")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/equipments",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("EQUIPMENTS.TITLE")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Diagnotics),
    _createVNode(Loading, {
      modelValue: _unref(isLoading),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isLoading) ? (isLoading).value = $event : null))
    }, null, 8, ["modelValue"])
  ], 2))
}
}

})